import { NgModule } from '@angular/core';
import { FormWidgetPersonComponent } from '@modules/bcm/@work-flows/@form-widgets/person/form-widget-person.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '@shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { GetAddressDialogModule } from '@shared/components';
import { HtmlLinksModule } from '@modules/bcm/@shared/components/html-links/html-links.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
    TenantRelationColoredLabelModule
} from '@modules/bcm/@shared/components/tenant-relation-colored-label/tenant-relation-colored-label.module';
import { PersonEditorDialogComponent } from './person-editor-dialog/person-editor-dialog.component';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { FormWidgetCountriesModule } from '../country-autocomplete/form-widget-countries.module';

@NgModule({
    declarations: [FormWidgetPersonComponent, PersonEditorDialogComponent],
    imports: [

        FuseSharedModule,
        SharedModule,

        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,

        GetAddressDialogModule,
        HtmlLinksModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        MatTooltipModule,
        TenantRelationColoredLabelModule,
        CdkDrag,
        CdkDragHandle,
        FormWidgetCountriesModule
    ],
    exports: [FormWidgetPersonComponent]
})
export class FormWidgetPersonModule {
    
}
